export const LEGACY_COMPONENT_PREFIX = 'wix.'
export const LEGACY_TYPES = new Set(['Page', 'Section', 'MasterPage'])
export const WIX_INNER_ELEMENT_TAG = 'wix-ie'
export const INNER_ELEMENT_TYPE_KEY = 'InnerElement'
export const RESERVED_ELEMENTS = {
    [INNER_ELEMENT_TYPE_KEY]: { tag: WIX_INNER_ELEMENT_TAG },
} as const
